import { toast } from 'react-toastify';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  notify(message: string, type: string, autoClose: number = 2000) {
    const options = { autoClose: autoClose, pauseOnHover: false, closeOnClick: true };
    switch (type) {
      case 'success':
        toast.success(message, options);
        break;
      case 'error':
        toast.error(message, options);
        break;
      case 'warn':
        toast.warn(message, options);
        break;
      case 'info':
        toast.info(message, options);
        break;
    }
  }
};
